import { useTranslation } from 'react-i18next'
import { KTSVG } from '../../../../_metronic/helpers'

type Props = {
	name: string;
	onAccess(): void;
	disabled?: boolean;
	loading?: boolean;
}

const SwitchAccountItem = ({ name, onAccess, disabled, loading }: Props) => {
	const { t } = useTranslation()

	return (
		<div
			className='fv-row  d-flex justify-content-between w-100 align-items-center account-row users-logins'
		>
			<div className='d-flex justify-content-center  flex-column'>
				<label className='form-label fw-bolder mb-0' style={{ fontSize: '14px' }}>{name}</label>
			</div>
			<button
				type='button'
				className='btn btn-light-primary access-btn radius-6'
				onClick={onAccess}
				disabled={disabled || loading}
			>
				{
					loading
						? <span className='indicator-progress' style={{ display: 'block' }}>
							<span className='spinner-border spinner-border-sm align-middle ms-2'></span>
						</span>
						: <>{t('access')}< KTSVG path='/media/icons/duotune/arrows/arr076.svg' className='m-0 p-0 ms-2' /></>
				}
			</button>
		</div>
	)
}

export default SwitchAccountItem;